import { buildEndpointUrl } from '@/_shared/helpers/makeSwaggerToEndpointUrl';
import { payloadToQueryParamsUrl } from '@/_shared/helpers/payloadToQueryParamsUrl';
import { GenericGet } from '@/_shared/types/swagger';
import {
  API_CHECK_CONFIRM_TOKEN_PATH_KEY,
  API_CHECK_INVITATIONS_ACCEPT_PATH_KEY,
} from '@/swagger/constants/slash-keys';

export const API_POST_ACCEPT_INVITATION = () => {
  return buildEndpointUrl(API_CHECK_INVITATIONS_ACCEPT_PATH_KEY, {});
};

type RequestGetConfirmToken = GenericGet<
  typeof API_CHECK_CONFIRM_TOKEN_PATH_KEY
>['request']['query'];

export const API_GET_CONFIRM_TOKEN = (params: RequestGetConfirmToken) => {
  const baseUrl = buildEndpointUrl(API_CHECK_CONFIRM_TOKEN_PATH_KEY, {});
  return payloadToQueryParamsUrl(params, baseUrl);
};
